<footer [ngClass]="{'desktop': !utilService.isMobile}">
  <mat-dialog-actions class="flex space-between flex-center flex-right"
                      [ngClass]="{'flex-end': !leftContent, 'flex-flat': !utilService.isMobile, 'flex-column-mobile': !noColumn}">
    <ng-container *ngIf="leftContent" [ngTemplateOutlet]="leftContent"></ng-container>
    <ng-content></ng-content>
  </mat-dialog-actions>
</footer>
